export default import.meta.ROLLUP_FILE_URL_OEnYfcMIk4zZrHiizmY4yQ;